import React, { useState, useEffect } from "react";
import { useCountdown } from "hooks/useCountDown";
import { classNames } from "utils/utils";

import {
  NOT_STARTED,
  FIRST_HALF,
  FULL_TIME,
  IN_PLAY_IN_2ND_HALF,
  HALF_TIME,
} from "utils/constants";

const EventTimeStatus = ({
  startTime,
  eventState,
  eventPeriods,
  vertical,
  gameRule,
  lastUpdatedAt,
  prediction,
}) => {
  /*   let [isEnabled, timerStarted, minutes, seconds] = useCountdown(
    startTime * 1000
  ); */

  let isEnabled = false;
  let eventStarted = false;
  let minutes = 0;
  let seconds = 0;

  let day = new Date(startTime * 1000).toLocaleString(undefined, {
    month: "2-digit",
    day: "2-digit",
  });

  let time = new Date(startTime * 1000).toLocaleString(undefined, {
    hour: "2-digit",
    hour12: false,
    minute: "2-digit",
  });

  let isToday = new Date(startTime * 1000).getDate() == new Date().getDate();

  const updatedAt = new Date(lastUpdatedAt * 1000);
  let diffInMilliSeconds = Math.abs(new Date() - updatedAt) / 1000;
  const minutesSinceUpdate = Math.floor(diffInMilliSeconds / 60) % 60;

  const getTimeTickerProps = () => {
    const defaultTickerProps = {
      minutes: 0,
      seconds: 0,
      ticking: false,
      addedTime: undefined,
    };

    if (eventState === FIRST_HALF || eventState === IN_PLAY_IN_2ND_HALF) {
      const period = eventPeriods.find((x) => x.ticking === true);

      let min = period?.minutes;

      // add minutes since update to fake live time
      if (lastUpdatedAt && minutesSinceUpdate) {
        min = min + minutesSinceUpdate;
      }

      if (period) {
        return {
          minutes: min,
          seconds: period?.seconds,
          ticking: period.ticking,
          addedTime: period.addedTime,
        };
      }
    }

    return defaultTickerProps;
  };

  //TODO: add states for extra time and penalties, as well as other pause and cancelled states
  const renderTime = () => {
    if (eventState == NOT_STARTED) {
      return isEnabled ? (
        `${minutes}:${seconds}`
      ) : (
        <div
          className={classNames(
            vertical ? "flex-col" : "flex-row",
            "flex items-end"
          )}
        >
          {!isToday && prediction && (
            <div className="font-light text-xs text-end">{day}</div>
          )}
          <div
            className={classNames(
              !vertical && "pl-1",
              "font-light text-xs text-end"
            )}
          >
            {time}
          </div>
        </div>
      );
    } else if (eventState === FULL_TIME) {
      return "FT";
    } else if (eventState === HALF_TIME) {
      return "HT";
    } else if (
      eventState === FIRST_HALF ||
      eventState === IN_PLAY_IN_2ND_HALF
    ) {
      const tickerProps = getTimeTickerProps();
      return <TimeTicker {...tickerProps} />;
    } else {
      return "-";
    }
  };

  return (
    <div
      className={classNames(
        vertical && "pl-2",
        gameRule == 1 || gameRule == 3 ? "hidden xxs:flex" : "flex",
        " items-center font-medium text-xs "
      )}
    >
      {renderTime()}
    </div>
  );
};

export default EventTimeStatus;

const TimeTicker = ({
  minutes = 0,
  seconds = 0,
  ticking = true,
  addedTime,
}) => {
  const [time, setTime] = useState({ minutes, seconds });

  useEffect(() => {
    let interval = null;

    const tick = () => {
      setTime((prevTime) => {
        let newMinutes = prevTime.minutes;
        let newSeconds = prevTime.seconds;

        if (newMinutes === undefined || newSeconds === undefined) {
          // Handle undefined minutes or seconds
          newMinutes = 0;
          newSeconds = 0;
        } else if (ticking) {
          newSeconds += 1;

          if (newSeconds === 60) {
            newMinutes += 1;
            newSeconds = 0;
          }
        }

        return { minutes: newMinutes, seconds: newSeconds };
      });
    };

    interval = setInterval(tick, 1000);

    return () => clearInterval(interval);
  }, [ticking, minutes, seconds]);

  const formatTime = (value) => {
    if (value === null || value === undefined) {
      return "00";
    }
    return value.toString().padStart(2, "0");
  };

  const displayTime = `${formatTime(time?.minutes)}:${formatTime(
    time?.seconds
  )}`;
  const displayAddedTime = addedTime !== undefined ? `+${addedTime}` : "";

  return <div>{`${displayTime} ${displayAddedTime}`}</div>;
};
